import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { HeroPanel, DetailTilesContainer, EnvironmentTitle } from 'view/shared/heroPanel'
import { WindowActions } from 'epics/windowEpic'
import { Translation, Locale } from 'locale'
import { useMidTradeEventsView } from './MidTradeEventsViewContext'

export const MidTradeEventsHeroPanel = () => {
  const view = useMidTradeEventsView() ?? ''
  const title = `${Locale.translate(Translation.TC_HERO_MID_POST_TRADE_EVENTS)}`
  const dispatch = useDispatch()
  const onTearout = useCallback(() => dispatch(WindowActions.tearoutGrid(`/quote/tearout/midTradeEvents/${view}`)), [dispatch, view])

  return (
    <HeroPanel onTearout={onTearout}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'MidTradeEventsHeroPanel-EnvironmentTitle'}>{title}</EnvironmentTitle>
      </DetailTilesContainer>
    </HeroPanel>
  )
}
